import Vue from 'vue'
import APIX from './index'

//查询应用配置
export const ApigetPageconfig = (params) => {
    return APIX.POST(params, "pageconfig/list")
}
// 获取顶部滚动公告
export const getNoticeByScroll = (params) => {
    return APIX.POST(params, "notice/getByScroll")
}
// 获取首页新闻
export const getNewsByPage = (params) => {
    return APIX.POST(params, "news/getByPage")
}
// 获取所有彩种
export const ApigetLotterylist = (params) => {
    return APIX.POST(params, "lottery/list")
}
// 获得所有彩票开奖信息
export const ApigetLotteryLatelyLpVo = (params) => {
    return APIX.POST(params, "lottery/getLotteryLatelyLpVo")
}
// 服务器时间
export const ApigetServerTime = (params = {}, header) => {
    return APIX.POST(params, "lottery/currentTime");
}
// 开奖历史
export const ApiqueryHisPeriodsPage = (params = {}, header) => {
    return APIX.POST(params, "lotteryperiods/queryHisPeriodsPage");
}
// 开奖历史
export const APIgetNewsDetailById = (params = {}, header) => {
    let str = '';
    for(let key in params){
        str += `${key}=${params[key]}&`;
    } 
    return APIX.POST(params, "/news/getById?"+str);
}


